<template>
  <div>
    <v-scroll-y-transition mode="out-in">
      <chip-status-click
        v-if="!loading"
        :status="status"
        @click="openModalForm(row.id)"
      />
      <v-progress-circular
        v-if="loading"
        indeterminate
        color="primary"
      />
    </v-scroll-y-transition>
    <template-modal
      color="primary"
      remove-divider
      :is-open="dialogForm"
      :header="$t('app.customers.modal.situationTitle')"
    >
      <template slot="content">
        <v-form
          ref="form"
          @submit.prevent="changeCustomerStatus()"
        >
          <v-layout
            row
            wrap
          >
            <v-flex xs12>
              <input-select
                v-model="statusSelected"
                :items="statusClient"
                item-value="value"
                item-text="text"
                required
                :return-object="false"
                counter="120"
                maxlength="120"
                :label="$t('app.customers.modal.status')"
              />
            </v-flex>
          </v-layout>
          <v-layout
            row
            justify-end
          >
            <v-flex xs3>
              <btn-flat
                color="grey"
                :text="$t('app.parameters.modal.cancel')"
                @click="onClose()"
              />
            </v-flex>
            <v-flex xs2>
              <btn-primary
                block
                :text="$t('app.parameters.modal.save')"
                type="submit"
                :loading="loading"
                :disabled="loading"
              />
            </v-flex>
          </v-layout>
        </v-form>
      </template>
    </template-modal>
  </div>
</template>

<script>
import StatusSituationClientEnum from 'Support/enums/StatusSituationClientEnum';
import PageableMixin from 'Support/components/lists/mixins/pageable.mixin';
import ChipStatusClick from 'Support/components/chips/ChipStatusClick.vue';
import NotificationMixin from 'Support/mixins/notification-mixin';
import CustomerRequest from 'Domain/customers/CustomerRequest';
import RouterMixin from 'Support/mixins/router-mixin';
import TemplateModal from 'Support/components/modals/TemplateModal.vue';
import InputSelect from 'Support/components/inputs/InputSelect.vue';
import BtnFlat from 'Support/components/buttons/BtnFlat.vue';
import BtnPrimary from 'Support/components/buttons/BtnPrimary.vue';

export default {
  name: 'CustomersStatusDataTableColumn',
  components: {
    ChipStatusClick,
    TemplateModal,
    InputSelect,
    BtnFlat,
    BtnPrimary,
  },
  mixins: [NotificationMixin, RouterMixin, PageableMixin],
  props: {
    value: {
      type: String,
      required: true,
    },
    row: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      statusClient: StatusSituationClientEnum,
      isOpen: false,
      statusSelected: '',
      reason: '',
      loading: false,
    };
  },
  computed: {
    status() {
      return this.value;
    },
  },
  created() {
    this.statusSelected = this.row.status;
  },
  methods: {
    onClose() {
      this.dialogForm = false;
      this.reason = '';
      this.$refs.form.resetValidation();
    },
    changeCustomerStatus() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.loading = true;
      const payload = {
        reason: this.reason,
        status: this.statusSelected,
      };

      CustomerRequest
        .blockOrActive(this.row.id, payload)
        .then(() => {
          this.updateQueryParams({ reload: Math.random() });
          this.showSuccessToast({
            text: this.$t('app.customers.list.statusSuccessMessage'),
          });
          this.loading = false;
        })
        .catch(({ response }) => {
          const { data } = response;
          this.showErrorToast({
            text: data.message,
          });
          this.loading = false;
        });
      this.onClose();
    },
  },
};
</script>
